import React from "react";
import { heroData } from "../../mock/portfolioData";

const sections = [
  { id: "about", label: "About" },
  { id: "skills", label: "Skills" },
  { id: "projects", label: "Projects" },
  { id: "experience", label: "Experience" },
  { id: "education", label: "Education" },
  { id: "contact", label: "Contact" },
];

function scrollToSection(sectionId) {
  const el = document.getElementById(sectionId);
  if (el) {
    el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}

export function SiteHeader() {
  return (
    <header className="sticky top-0 z-20 border-b border-slate-800/80 bg-black/80 backdrop-blur-md">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="text-left"
        >
          <p className="retro-nav-link mb-0.5 font-semibold text-cyan-300">
            PORTFOLIO
          </p>
          <p className="font-mono text-sm font-semibold text-slate-50">
            {heroData.name}
          </p>
        </button>
        <nav className="hidden items-center gap-1 text-xs text-slate-300 sm:flex">
          {sections.map((section) => (
            <button
              key={section.id}
              type="button"
              onClick={() => scrollToSection(section.id)}
              className="retro-nav-link relative overflow-hidden rounded-full px-3 py-1 text-slate-300 transition-colors hover:bg-slate-900 hover:text-cyan-200"
            >
              <span className="relative z-10">{section.label}</span>
              <span className="pointer-events-none absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-cyan-400/80 to-transparent opacity-60" />
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
}

export default SiteHeader;
